import { render } from "./a-score.vue?vue&type=template&id=2e96545d&scoped=true"
import script from "./a-score.vue?vue&type=script&lang=js"
export * from "./a-score.vue?vue&type=script&lang=js"

import "./a-score.vue?vue&type=style&index=0&id=2e96545d&scoped=scoped&lang=less"

import exportComponent from "D:\\project\\BidData\\code\\xyf_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e96545d"]])

export default __exports__